const BaseURL = {
  EvaGroup: '/eva/group',
  EvaOrganization: '/eva/organization',
};

export default BaseURL;
